module.exports = __webpack_public_path__ + "img/icon-delete-red.e72100eb.svg";